import { useTheme } from "@/theme/ThemeProvider";
import { useStyles } from "@/theme/styles";
import { HeartIcon, BellIcon, BellSlashIcon } from "phosphor-react-native";
import React from "react";
import { Pressable, Text, View } from "react-native";

type Props = {
  watching: boolean;
  notifyEnabled?: boolean;
  disabled?: boolean;
  showNotifyToggle?: boolean;
  onToggleWatch: (watching: boolean) => void;
  onToggleNotify?: (enabled: boolean) => void;
};

/**
 * Herz = favorisieren/beobachten; optional Benachrichtigungs-Toggle.
 */
export function WatchToggle({
  watching,
  notifyEnabled = true,
  disabled,
  showNotifyToggle,
  onToggleWatch,
  onToggleNotify,
}: Props) {
  const { theme } = useTheme();
  const s = useStyles();
  const showNotify = showNotifyToggle ?? watching;

  return (
    <View style={{ flexDirection: "row", alignItems: "center", gap: theme.space.md }}>
      <Pressable
        disabled={disabled}
        onPress={() => onToggleWatch(!watching)}
        accessibilityRole="button"
        accessibilityLabel={watching ? "Nicht mehr beobachten" : "Beobachten"}
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: theme.space.xs,
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <HeartIcon
          size={22}
          weight={watching ? "fill" : "regular"}
          color={watching ? theme.color.danger : theme.color.muted}
        />
        <Text style={[s.textTiny, { color: theme.color.muted }]}>
          {watching ? "Favorit" : "Merken"}
        </Text>
      </Pressable>

      {showNotify && onToggleNotify ? (
        <Pressable
          disabled={disabled || !watching}
          onPress={() => onToggleNotify(!notifyEnabled)}
          accessibilityRole="button"
          accessibilityLabel={
            notifyEnabled
              ? "Benachrichtigungen ausschalten"
              : "Benachrichtigungen einschalten"
          }
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: theme.space.xs,
            opacity: disabled || !watching ? 0.5 : 1,
          }}
        >
          {notifyEnabled ? (
            <BellIcon size={20} color={theme.color.primary} />
          ) : (
            <BellSlashIcon size={20} color={theme.color.muted} />
          )}
          <Text style={[s.textTiny, { color: theme.color.muted }]}>
            {notifyEnabled ? "Benachrichtigungen an" : "Stumm"}
          </Text>
        </Pressable>
      ) : null}
    </View>
  );
}
